import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Footer from '../Components/Footer';
import Header from '../Components/Header';
import HowItWorksImg from "./../Images/how-it-works.png";
import { FaChevronRight } from "react-icons/fa";
// import Client from '../Home/Client/Client';
// import Footer from '../Components/Footer';
// import PageTitle from '../PageTitle/PageTitle';
// import Footer from '../Share/Footer/Footer';
// import Nav from '../Share/Nav/Nav';
// import { Button } from 'react-bootstrap';

const MyAccount = () => {
    const [file, setFile] = useState();
    const [filename, setFilename] = useState();

    const hiddenFileInput = React.useRef(null);

    const handleClick = event => {
        hiddenFileInput.current.click();
    };
    function handleChange(e) {
        console.log(e.target.files);

        setFilename(e.target.files[0].name);
        setFile(URL.createObjectURL(e.target.files[0]));

    }
    return (
        <>
            <Header />

            <div
                className="banner w-100"
                style={{ backgroundImage: `url(${HowItWorksImg})` }}
            >
                <div className="container">
                    <div className="banner-title text-center">
                        <h1>My Account</h1>
                        <p>
                            <Link to="/">Home</Link>{" "}
                            <span>
                                <FaChevronRight />
                            </span>{" "}
                            My Account
                        </p>
                    </div>
                </div>
            </div>
            <div>
                {/* Contact-us */}

                <section className="contact py-5 bg-light">
                    <div className="container  pb-5">
                        <div className='row'>
                            <div className='col-lg-2'></div>
                            <div className='col-lg-8'>
                                <div className="contact-form mt-5 p-4 shadow bg-white">
                                    <div className="d-flex justify-content-between">

                                        <div className="input-title  mb-4">
                                            <h3>My Account</h3>
                                        </div>
                                        <div className="contact-sub-head text-end mb-3">
                                            {/* <h4><FiUsers/> User List</h4> */}
                                            <Link className='add-user' to="/edit-profile">Edit Profile</Link>
                                        </div>
                                    </div>
                                    <form action="#" method="post">
                                        <div className="row">
                                            <div className="form-group col-12 col-md-6">
                                                <input type="text" className="form-control mb-4" id="" name="" placeholder="First Name" />
                                            </div>

                                            <div className="col-12 col-md-6">
                                                <input type="text" className="form-control mb-4" id="" name="" placeholder="Last Name" />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <input type="text" className="form-control mb-4" id="" name="" placeholder="E-mail" />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <input type="Number" className="form-control mb-4" id="" name="" placeholder="Phone Number" />
                                            </div>
                                            <div className="col-12 col-md-6">
                                                <input type="password" className="form-control mb-4" id="" name="" placeholder="Password" />
                                            </div>

                                            <div className="col-12 col-md-6">
                                                <img className='upload-img' src={file} />
                                                <span className='file-name'>{filename}</span>
                                                {/* <label htmlFor="file">{file}</label> */}
                                                <span className="upld-btn" onClick={handleClick}>
                                                    <i class="bi bi-upload"></i>  Upload New Image
                                                </span>
                                                <input type="file"
                                                    ref={hiddenFileInput}
                                                    onChange={handleChange}
                                                    style={{ display: 'none' }}
                                                />

                                                {/* <input name='name' id='file' type="file" placeholder='upload the file' onChange={handleChange} /> */}

                                            </div>

                                        </div>
                                    </form>
                                </div>
                                <div className='col-lg-2'></div>
                            </div>
                        </div>
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default MyAccount;